/* 5 Star Cycles - Size/Position picker fix (View options popup + product page).
   1) Picking a size auto-sets its Position (and picking a Position auto-picks a valid size),
      so the SKU / price / stock / photos always match and "Unavailable" no longer sticks.
   2) Shows each size's price in the Size dropdown.
   3) Front / Rear buttons replace the Position dropdown; the Size list only shows sizes for the chosen position.
      On product pages this also hides the Rubik swatch picker for these tires so the buttons are the only picker.
   4) Bigger price in the View options popup.
   The theme re-renders the picker after every click, so everything is re-applied instantly (no flicker).
   5) (second block at the bottom) Footer Google review count + star rating update automatically. */
(function () {
  if (window.__fscVariantFix) return;
  window.__fscVariantFix = true;
  var css = document.createElement('style');
  css.textContent = 'article[class*="m6pr-quickshop-"] .f8pr-price{font-size:28px;font-weight:800;line-height:1.2}' +
    'article[class*="m6pr-quickshop-"] .f8pr-price .old-price{font-size:17px;font-weight:400}' +
    '.fsc-pdp-on rubik-swatch{display:none!important}.fsc-pdp-on .f8pr-variant-selection{display:block!important}' +
    '[data-fsc-multi] p:has(select[name$="-Position]"]){display:none!important}' +
    '.fsc-pos{margin:0 0 16px}.fsc-pos-l{display:block;font-weight:700;margin:0 0 8px}' +
    '.fsc-pos .fsc-pos-b{display:flex;gap:10px}' +
    '.fsc-pos .fsc-pos-b button{flex:1;position:relative;background:#fff!important;background-image:none!important;color:#1c1c1c!important;border:2px solid #1c1c1c!important;box-shadow:none!important;min-height:0!important;height:auto!important;line-height:1.2!important;padding:13px 10px!important;border-radius:6px!important;font-size:15px!important;font-weight:800!important;letter-spacing:.05em;text-transform:uppercase;cursor:pointer;transition:all .15s}' +
    '.fsc-pos .fsc-pos-b button::before,.fsc-pos .fsc-pos-b button::after{display:none!important;content:none!important}' +
    '.fsc-pos .fsc-pos-b button:hover{border-color:#d9453d!important;color:#d9453d!important}' +
    '.fsc-pos .fsc-pos-b button.on,.fsc-pos .fsc-pos-b button.on:hover{background:#d9453d!important;border-color:#d9453d!important;color:#fff!important}';
  document.head.appendChild(css);
  var data = {}, loading = {};
  function money(c) { return '$' + (Number(c) / 100).toFixed(2); }
  function isSel(s, w) { return s && s.tagName === 'SELECT' && new RegExp('(^|[-\\[ ])' + w + '\\]?$', 'i').test(s.name || ''); }
  function isQuick(el) { return !!(el && el.closest && el.closest('article[class*="m6pr-quickshop-"]')); }
  function ctx(sel) {
    var a = sel.closest('article[data-product-url]');
    if (a) return { root: a, url: String(a.getAttribute('data-product-url')).split('?')[0].split('#')[0] };
    if (/^\/products\//.test(location.pathname)) return { root: document, url: location.pathname };
    return null;
  }
  function find(root, w) {
    return [].filter.call(root.querySelectorAll('select'), function (s) { return isSel(s, w); })[0];
  }
  function lis(sel) {
    var b = sel && sel.nextElementSibling;
    return b ? [].filter.call(b.querySelectorAll('.bv_ul_inner .li'), function (l) { return l.querySelector('.text'); }) : [];
  }
  function build(p) {
    var names = (p.options || []).map(function (o) { return String(o && o.name ? o.name : o).toLowerCase(); });
    var si = names.indexOf('size'), pi = names.indexOf('position');
    if (si < 0 || pi < 0) return null;
    var pos = {};
    p.variants.forEach(function (v) { pos[v.options[pi]] = 1; });
    return {
      si: si, pi: pi, variants: p.variants, multi: Object.keys(pos).length > 1,
      find: function (s, q) {
        return p.variants.filter(function (v) { return v.options[si] === s && (q == null || v.options[pi] === q); })[0];
      }
    };
  }
  function load(url, cb) {
    if (data[url]) return cb(data[url]);
    if (loading[url]) return;
    loading[url] = 1;
    fetch(url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (p) { data[url] = build(p) || { none: 1 }; cb(data[url]); })
      .catch(function () { loading[url] = 0; });
  }
  function setSel(sel, val) {
    sel.value = val;
    var inner = sel.nextElementSibling && sel.nextElementSibling.querySelector('.sl_inner');
    var o = sel.options[sel.selectedIndex];
    if (inner && o) inner.textContent = o.textContent;
  }
  function ensureButtons(root, d) {
    var sz = find(root, 'Size'), ps = find(root, 'Position');
    if (!sz || !ps) return;
    var szP = sz.closest('p') || sz.parentElement, psP = ps.closest('p');
    (root === document ? document.documentElement : root).setAttribute('data-fsc-multi', '1');
    if (psP) psP.style.display = 'none';
    if (!isQuick(sz)) document.documentElement.classList.add('fsc-pdp-on');
    var bar = root.querySelector('.fsc-pos');
    if (!bar) {
      var order = [];
      d.variants.forEach(function (v) { if (order.indexOf(v.options[d.pi]) < 0) order.push(v.options[d.pi]); });
      order.sort(function (x, y) { return x === 'Front' ? -1 : y === 'Front' ? 1 : 0; });
      bar = document.createElement('div');
      bar.className = 'fsc-pos';
      bar.innerHTML = '<span class="fsc-pos-l">Position</span><div class="fsc-pos-b"></div>';
      order.forEach(function (p) {
        var bt = document.createElement('button');
        bt.type = 'button'; bt.setAttribute('data-pos', p); bt.textContent = p;
        bar.lastChild.appendChild(bt);
      });
      szP.parentNode.insertBefore(bar, szP);
    }
    [].forEach.call(bar.querySelectorAll('button'), function (bt) {
      var on = bt.getAttribute('data-pos') === ps.value;
      bt.classList.toggle('on', on);
      bt.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function annotate(root, d) {
    var sz = find(root, 'Size'), ps = find(root, 'Position');
    if (!sz || !ps) return;
    if (d.multi) ensureButtons(root, d);
    var l = lis(sz);
    [].forEach.call(sz.options, function (o, i) {
      var v = d.find(o.value, ps.value) || d.find(o.value, null);
      if (!v) return;
      var t = o.value + ' — ' + money(v.price) + (v.available ? '' : ' (sold out)');
      if (o.textContent !== t) o.textContent = t;
      var show = !d.multi || !!d.find(o.value, ps.value);
      o.hidden = !show;
      var li = l[i];
      if (li) {
        var sp = li.querySelector('.text');
        if (sp && sp.textContent !== t) sp.textContent = t;
        li.style.display = show ? '' : 'none';
        li.classList.toggle('active', i === sz.selectedIndex);
      }
    });
    var inner = sz.nextElementSibling && sz.nextElementSibling.querySelector('.sl_inner');
    var cur = sz.options[sz.selectedIndex];
    if (inner && cur && inner.textContent !== cur.textContent) inner.textContent = cur.textContent;
  }
  /* Front / Rear button click */
  document.addEventListener('click', function (e) {
    var bt = e.target.closest && e.target.closest('.fsc-pos-b button');
    if (!bt) return;
    e.preventDefault();
    var a = bt.closest('article[data-product-url]');
    var root = a || document;
    var url = a ? String(a.getAttribute('data-product-url')).split('?')[0].split('#')[0] : location.pathname;
    var d = data[url];
    if (!d || d.none) return;
    var sz = find(root, 'Size'), ps = find(root, 'Position'), pos = bt.getAttribute('data-pos');
    if (!sz || !ps || ps.value === pos) return;
    retag();
    setSel(ps, pos);
    if (!d.find(sz.value, pos)) {
      var first = d.variants.filter(function (x) { return x.options[d.pi] === pos; })[0];
      if (first) setSel(sz, first.options[d.si]);
    }
    annotate(root, d);
    var ev = new Event('change', { bubbles: true });
    ev.__fsc = true;
    ps.dispatchEvent(ev);
    setTimeout(function () { syncSku(root, d); }, 500);
    setTimeout(function () { syncSku(root, d); }, 1200);
  });
  function syncSku(root, d) {
    var idEl = root.querySelector('input[name="id"]'), sk = root.querySelector('.pdp-sku');
    if (!idEl || !sk || !idEl.value) return;
    var v = d.variants.filter(function (x) { return String(x.id) === String(idEl.value); })[0];
    if (v && v.sku) { sk.textContent = 'SKU: ' + v.sku; sk.style.display = ''; }
  }
  /* BVSelect fires "change" a moment BEFORE it stores the new value, so the theme was reading the
     previous pick (the wrong-tire / wrong-SKU bug). We hold that early event, wait for the value to
     settle, make Size + Position a valid pair, then fire one clean "change". */
  document.addEventListener('change', function (e) {
    if (e.__fsc) return;
    var t = e.target, which = isSel(t, 'Size') ? 'size' : isSel(t, 'Position') ? 'pos' : '';
    if (!which) return;
    var c = ctx(t), d = c && data[c.url];
    if (!d || d.none) return;
    e.stopImmediatePropagation();
    setTimeout(function () {
      retag();
      var sz = find(c.root, 'Size'), ps = find(c.root, 'Position');
      if (sz && ps && !d.find(sz.value, ps.value)) {
        if (which === 'size') {
          var v = d.find(sz.value, null);
          if (v) setSel(ps, v.options[d.pi]);
        } else {
          var w = d.variants.filter(function (x) { return x.options[d.pi] === ps.value; })[0];
          if (w) setSel(sz, w.options[d.si]);
        }
      }
      if (sz && ps) annotate(c.root, d);
      var ev = new Event('change', { bubbles: true });
      ev.__fsc = true;
      t.dispatchEvent(ev);
      setTimeout(function () { syncSku(c.root, d); }, 500);
      setTimeout(function () { syncSku(c.root, d); }, 1200);
    }, 0);
  }, true);
  /* The theme swaps the popup's form with fresh HTML after the first pick and drops the "quickshop-" prefix
     from data-template, after which it ignores further changes. Put the prefix back. */
  function retag() {
    [].forEach.call(document.querySelectorAll('article[class*="m6pr-quickshop-"]'), function (a) {
      var m = String(a.className).match(/m6pr-(quickshop-\S+)/);
      if (!m) return;
      var form = a.querySelector('form.f8pr'), fid = form && form.getAttribute('id');
      [].forEach.call(a.querySelectorAll('[data-template]'), function (e) {
        var tpl = e.getAttribute('data-template') || '';
        if (tpl.indexOf('quickshop-') !== 0 && 'quickshop-' + tpl === m[1]) {
          e.setAttribute('data-template', m[1]);
          if (fid && e.hasAttribute('form')) e.setAttribute('form', fid);
        }
      });
    });
  }
  function scan() {
    retag();
    [].forEach.call(document.querySelectorAll('select'), function (s) {
      if (!isSel(s, 'Size')) return;
      var c = ctx(s);
      if (!c) return;
      load(c.url, function (d) { if (d && !d.none) annotate(c.root, d); });
    });
  }
  /* run right away on every DOM change (a MutationObserver callback runs before the browser paints) */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { scan(); return; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();

/* ---- Footer Google reviews: live rating + review count ----
   Reads https://script.google.com/... (your Apps Script, which asks Google Places once every 6 hours).
   Updates the big rating number, the stars (exact fill, e.g. 4.4 = 4 full + 40%), the "N Google Reviews" line
   and the "X Star Rating · N Reviews" line in the Google Trusted box. If the feed is down the footer keeps
   the last numbers it saw. */
(function () {
  if (window.__fscLiveReviews) return;
  window.__fscLiveReviews = true;
  var FEED = 'https://script.google.com/macros/s/AKfycbwI9wkLE9fgtOHaW21oB_QRi8TEAVKW_TR2qGwbBFbNUq_nDhTq972fW6p9Yq1b_W0cQw/exec';
  var KEY = 'fscLiveReviews', FRESH_MS = 30 * 60 * 1000;
  var st = document.createElement('style');
  st.textContent = '.fsc-testimonials-summary-stars .fsc-star-live{position:relative;display:inline-block;width:1em;color:rgba(255,255,255,.18)}' +
    '.fsc-testimonials-summary-stars .fsc-star-live::before{content:"\\2605";position:absolute;top:0;left:0;width:var(--fsc-fill,100%);overflow:hidden;color:var(--fsc-gold,#f4d40b)}';
  document.head.appendChild(st);
  function apply(d) {
    var rating = Number(d && d.rating), count = Number(d && d.count);
    if (!(rating > 0 && rating <= 5) || !(count > 0)) return;
    var sec = document.querySelector('.fsc-testimonials-section');
    if (!sec) return;
    var r = rating.toFixed(1), c = Math.round(count).toLocaleString('en-US');
    var num = sec.querySelector('.fsc-testimonials-rating-number');
    if (num && num.firstChild && num.firstChild.nodeType === 3) num.firstChild.nodeValue = r;
    var stars = sec.querySelector('.fsc-testimonials-summary-stars');
    if (stars) {
      stars.setAttribute('aria-label', r + ' out of 5 stars');
      stars.innerHTML = '';
      for (var i = 0; i < 5; i++) {
        var s = document.createElement('span');
        s.className = 'fsc-star-live';
        s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--fsc-fill', Math.round(Math.max(0, Math.min(1, rating - i)) * 100) + '%');
        s.textContent = '★';
        stars.appendChild(s);
      }
    }
    var cnt = sec.querySelector('.fsc-testimonials-review-count');
    if (cnt) cnt.textContent = c + ' Google Reviews';
    var desc = sec.querySelector('.fsc-testimonials-trust-item-link .fsc-testimonials-trust-description');
    if (desc) desc.textContent = r + ' Star Rating · ' + c + ' Reviews';
  }
  var cached = null;
  try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (cached) apply(cached);
  if (cached && cached.t && Date.now() - cached.t < FRESH_MS) return;
  fetch(FEED).then(function (r) { return r.json(); }).then(function (d) {
    if (!d || d.error || !(Number(d.rating) > 0) || !(Number(d.count) > 0)) return;
    apply(d);
    try { localStorage.setItem(KEY, JSON.stringify({ rating: d.rating, count: d.count, t: Date.now() })); } catch (e) {}
  }).catch(function () {});
})();
